import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, Check, X } from "lucide-react";
import { confirmNewsletter } from "../lib/api";

export default function NewsletterConfirmPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = React.useState("loading");

  React.useEffect(() => {
    if (!token) {
      setState("missing");
      return;
    }
    confirmNewsletter(token)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <main
      data-testid="newsletter-confirm-page"
      className="min-h-[100svh] flex items-center justify-center px-6"
    >
      <div className="max-w-lg w-full bg-white border border-[#E5E0D8] p-12 text-center">
        {state === "loading" && (
          <div className="flex flex-col items-center gap-4">
            <Loader2 size={28} className="animate-spin text-[#0B3D5C]" />
            <p className="font-serif-body text-[#4A4A4A]">Confirming...</p>
          </div>
        )}
        {state === "ok" && (
          <>
            <div className="w-12 h-12 mx-auto rounded-full bg-[#0B3D5C] text-white flex items-center justify-center">
              <Check size={22} />
            </div>
            <h1 className="h-section text-[2rem] mt-5">You're in.</h1>
            <p className="font-serif-body text-[#4A4A4A] mt-4 text-[1.05rem] leading-relaxed">
              Thanks for confirming. You'll hear from Atlas when there's
              something worth your time. Not before.
            </p>
          </>
        )}
        {(state === "error" || state === "missing") && (
          <>
            <div className="w-12 h-12 mx-auto rounded-full bg-[#7A2E2E] text-white flex items-center justify-center">
              <X size={22} />
            </div>
            <h1 className="h-section text-[2rem] mt-5">Link expired</h1>
            <p className="font-serif-body text-[#4A4A4A] mt-4 text-[1.05rem] leading-relaxed">
              This confirmation link is no longer valid. Unconfirmed
              requests auto-expire after 72 hours. Resubscribe from the
              footer and we'll send a fresh one.
            </p>
          </>
        )}
        <Link to="/" className="btn btn-dark mt-8 inline-flex">
          Back to leadriver.ai
        </Link>
      </div>
    </main>
  );
}
